module.exports = __webpack_public_path__ + "media/images/icon-download-d595d207d3eaafaa8365fb575c956567.png";